import { useEffect, useRef, useCallback, useState } from "react";
import sessionConfig from "../../../src/sessionConfig.json";

export default function useSessionTimeout({ timeoutMinutes = sessionConfig.sessionTimeoutMinutes, onTimeout }) {
  const timeoutRef = useRef(null);

  const resetTimer = useCallback(() => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(
      () => {
        onTimeout();
      },
      timeoutMinutes * 60 * 1000,
    );
  }, [timeoutMinutes, onTimeout]);

  useEffect(() => {
    const events = [
      "mousemove",
      "mousedown",
      "keydown",
      "touchstart",
      "scroll",
      "click",
    ];
    events.forEach((e) => window.addEventListener(e, resetTimer));
    resetTimer();
    return () => {
      clearTimeout(timeoutRef.current);
      events.forEach((e) => window.removeEventListener(e, resetTimer));
    };
  }, [resetTimer]);
}